import Vue from 'vue';
import Tracking from '@app/tracking';
export default Vue.extend({
    props: {
        autoAccept: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            consentGiven: this.$helpers.storage.get('cookie-consent-given'),
            countdown: this.autoAccept
        };
    },
    mounted: function () {
        var _this = this;
        if (!this.consentGiven && this.autoAccept) {
            var countdownTimer_1 = setInterval(function () {
                _this.countdown = _this.countdown - 1;
                if (_this.countdown <= 0) {
                    _this.dismiss();
                    clearInterval(countdownTimer_1);
                }
            }, 1000);
        }
    },
    methods: {
        dismiss: function () {
            this.consentGiven = 'yes';
            this.$helpers.storage.set('cookie-consent-given', 'yes');
        },
        decline: function () {
            Tracking.stop();
            this.consentGiven = 'no';
            this.$helpers.storage.set('cookie-consent-given', 'no');
        }
    }
});
